import { useState, useEffect, useLayoutEffect } from "react";
import classes from "./Widget.module.scss";
import Stepper from "../Stepper/Stepper.js";
import Step1 from "../Steps/Step1";
import Step2 from "../Steps/Step2.js";
import useMobile from "../../hooks/useMobile.js";
import Search from "../Search/Search.js";
import Finish from "../Steps/Finish.js";
import { toast } from "react-toastify";
import CustomModal from "./CustomModal";
import { useQuery, useMutation } from "@tanstack/react-query";
import moment from "moment";
import { ThemeProvider, createTheme } from "@mui/material";
import Cookies from "js-cookie";
import { useHistory, useLocation } from "react-router-dom";

import {
  getStructuredServices,
  confirmNumber,
  loadBookingData,
  loadUpsellServices,
  getFreeSlots,
  doBooking,
} from "../../models/models.js";
import Cart from "../Cart/Cart.js";
import Stepbetween1and2 from "../Steps/Step1-2.js";
import Utilities from "../utils/Utilities";
import logo from "../../assets/Logo-nero 1.svg";
import Step3 from "../Steps/Step3.js";
import { useForm } from "react-hook-form";
import usePreferencesStore from "../../store/preferencesStore.js";
// import { useNavigate } from "react-router-dom";

function removeDuplicates(arr, prop) {
  return arr.filter(
    (obj, index, self) => index === self.findIndex((t) => t[prop] === obj[prop])
  );
}

const Widget = () => {
  const { setupPreferences } = usePreferencesStore();
  const isMobile = useMobile();
  // const navigate = useNavigate();
  const [currentStep, seCurrenttStep] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [services, setServices] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [stepBetween1and2Loading, setStepBetween1and2Loading] = useState(false);
  const [preferences, setPreferences] = useState({});
  const [originalServices, setOriginalServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [isConfirmButtonEnabled, setIsConfirmButtonEnabled] = useState(false);
  const [selectedServicesForNextStep, setSelectedServicesForNextStep] =
    useState([]);
  const [selectedServicesFromUrl, setSelectedServicesFromUrl] = useState([]);
  const [
    isMultiSelectConfirmationVisible,
    setIsMultiSelectConfirmationVisible,
  ] = useState(false);
  const [itemBeingSelected, setItemBeingSelected] = useState({});
  const [finished, setFinished] = useState(false);
  const [payOnline, setPayOnline] = useState(true);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [showMobileVerificationModal, setShowMobileVerificationModal] =
    useState(false);
  const [showStripeModal, setShowStripeModal] = useState(false);
  const [isInFlight, setIsInFlight] = useState(false);
  const [phone, setPhone] = useState("");
  const [errorMobile, setErrorMobile] = useState(false);
  const [mobile, setMobile] = useState("");
  const [confirmButtonClicked, setConfirmButtonClicked] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    trigger,
    watch,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if (preferences) {
      setupPreferences(preferences);
    }
  }, [preferences]);

  // step 2 param starts
  const [freeSlots, setFreeSlots] = useState();
  const [selectedDay, setSelectedDay] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState();
  const [finishedWithError, setFinishedWithError] = useState(false);
  const [errorInStripe, setErrorInStripe] = useState(false);
  const [noAvailableSlots, setNoAvailableSlots] = useState();
  const [isSettingUpConfig, setSettingUpConfig] = useState(true);
  const [cookieData, setCookieData] = useState();
  // step 2 param ends

  const [itemBeingSelectedDependencies, setItemBeingSelectedDependencies] =
    useState([]);

  // using @tanstack/react-query to loading initial data.
  const {
    isPending,
    error: errorBookingData,
    data: bookingData,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["bookingData"],
    queryFn: () => loadBookingData(),
  });
  // using @tanstack/react-query to mutate data.
  const { mutate, data: upsellServicesData } = useMutation({
    mutationFn: () =>
      loadUpsellServices(
        selectedServices,
        employees,
        setStepBetween1and2Loading
      ),
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userData = queryParams.get("user");
    if (userData) {
      console.log("userData", userData);
      setCookieData(userData);
    } else {
      setCookieData({});
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {}, 500);
  }, []);

  useEffect(() => {
    if (finished) window.parent?.postMessage("finished", "*");
  }, [finished]);

  function hexToRgba(hex, opacity) {
    // Rimuovi il carattere '#' se presente
    hex = hex.replace("#", "");

    // Converti il colore hex in valori r, g, b
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Costruisci la stringa rgba
    let rgba = `rgba(${r}, ${g}, ${b}, ${opacity})`;

    return rgba;
  }

  useEffect(() => {
    const handleMessage = ({ data }) => {
      if (data === "back") {
        const destination = currentStep - 1;
        if (currentStep !== 1 && finished === false) {
          if (destination % 1 !== 0) {
            seCurrenttStep(1);
          } else if (
            currentStep < 3 ||
            (currentStep === 3 && finished === false)
          ) {
            seCurrenttStep(destination);
          } else if (currentStep === 3 && finished === true) {
            alert(finished);
            window.parent?.postMessage("homepage", "*");
          }
        } else {
          window.parent?.postMessage("homepage", "*");
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [currentStep, finished]);

  const selectServicesFromUrl = (serviceIds) => {
    const element = document.getElementById(serviceIds[0]);
    console.log("Element", element);
    if (element) {
      const topOffset = 100;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - topOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    const servicesToSelect = [];
    const depsToSelect = [];
    if (serviceIds.length > 0) {
      serviceIds.forEach((id) => {
        const service = originalServices.find(
          (s) => s.id_service === id.toString()
        );
        console.log("Service found", service, id, originalServices);
        if (service) {
          const deps = Utilities.getServiceDependencies(
            originalServices,
            service
          );
          servicesToSelect.push({
            id_service: service.id_service,
            name: service.name,
            idStaffItem: service.idStaffItem ? service.idStaffItem : "",
            selectionMode: Utilities.MANUAL,
            sortOrder: servicesToSelect.length + 1,
          });

          deps.forEach((dep, index) => {
            depsToSelect.push({
              id_service: dep.id_service,
              name: dep.name,
              idStaffItem: dep.idStaffItem ? dep.idStaffItem : "",
              selectionMode: Utilities.INCLUDED,
              parentItemId: service.id_service,
              sortOrder: servicesToSelect.length + 1 + index + 1,
            });
          });
        }
      });

      const allServicesToSelect = [...servicesToSelect, ...depsToSelect];

      console.log("all services", allServicesToSelect);
      setSelectedServices(allServicesToSelect);
      setSelectedServicesFromUrl(allServicesToSelect);
      addOrEditSelectedServices(allServicesToSelect);
      const currentUrl = new URL(window.location.href);
      const queryParams = new URLSearchParams(currentUrl.search);
      if (queryParams.get("step")) gotoNext();
    }
  };

  const convertServiceIdsToSelectedServices = (
    serviceIds,
    originalServices
  ) => {
    const servicesToSelect = [];
    const depsToSelect = [];

    if (serviceIds.length > 0) {
      serviceIds.forEach((id) => {
        const service = originalServices.find(
          (s) => s.id_service === id.toString()
        );
        console.log("Service found", service, id, originalServices);
        if (service) {
          const deps = Utilities.getServiceDependencies(
            originalServices,
            service
          );
          servicesToSelect.push({
            id_service: service.id_service,
            name: service.name,
            idStaffItem: service.idStaffItem ? service.idStaffItem : "",
            selectionMode: Utilities.MANUAL,
            sortOrder: servicesToSelect.length + 1,
          });

          deps.forEach((dep, index) => {
            depsToSelect.push({
              id_service: dep.id_service,
              name: dep.name,
              idStaffItem: dep.idStaffItem ? dep.idStaffItem : "",
              selectionMode: Utilities.INCLUDED,
              parentItemId: service.id_service,
              sortOrder: servicesToSelect.length + 1 + index + 1,
            });
          });
        }
      });

      const allServicesToSelect = [...servicesToSelect, ...depsToSelect];
      console.log("all services", allServicesToSelect);
      return allServicesToSelect;
    } else return [];
  };

  const [hasProcessedServices, setHasProcessedServices] = useState(false);

  useLayoutEffect(() => {
    if (!hasProcessedServices && bookingData?.services) {
      const currentUrl = new URL(window.location.href);
      const queryParams = new URLSearchParams(currentUrl.search);
      const servicesParam = queryParams.get("services");

      if (servicesParam) {
        const servicesArray = servicesParam
          .replace(/\s/g, "")
          .slice(1, -1)
          .split(",")
          .map(Number);

        if (originalServices.length > 0) {
          setTimeout(() => {
            selectServicesFromUrl(servicesArray);
            setHasProcessedServices(true);
          }, 500);
        }
      }
    }
  }, [bookingData, hasProcessedServices, originalServices]);

  useEffect(() => {
    if (bookingData && bookingData.services.length) {
      //Quindi, il colore primario e  l'hover fa lighten al 10%.
      document.documentElement.style.setProperty(
        "--primaryColor",
        bookingData.preferences.main_color
      );
      document.documentElement.style.setProperty(
        "--primaryColorHover",
        bookingData.preferences.main_color
      );
      document.documentElement.style.setProperty(
        "--primaryColor50",
        hexToRgba(bookingData.preferences.main_color, 0.05)
      );
      document.documentElement.style.setProperty(
        "--primaryColor05",
        hexToRgba(bookingData.preferences.main_color, 0.05)
      );

      const array = removeDuplicates(bookingData.services, "id_service");
      console.log(array);
      setServices(array);
      setOriginalServices(bookingData.services);
      setEmployees(bookingData.employees);
      setPreferences(bookingData.preferences);
      setPayOnline(bookingData.preferences.online_payment_enabled);
      setSettingUpConfig(false);
    }
  }, [bookingData]);

  const theme = createTheme({
    palette: {
      primary: {
        main:
          bookingData !== undefined
            ? bookingData.preferences.main_color
            : "#2645e6",
      },
    },
  });

  useEffect(() => {
    if (upsellServicesData) {
      if (upsellServicesData.services.length) {
        const array = removeDuplicates(
          upsellServicesData.services,
          "id_service"
        );
        setServices(array);
        seCurrenttStep(1.2);
      } else if (upsellServicesData.services.length === 0) {
        const array = removeDuplicates(originalServices, "id_service");
        setServices(array);
        seCurrenttStep(2);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upsellServicesData]);

  const onStepChange = (step) => {
    if (step === 1) {
      const array = removeDuplicates(originalServices, "id_service");
      setServices(array);
      const url = new URL(window.location);
      url.searchParams.delete("step");
      window.history.replaceState({}, "", url);
    } else if (step === 2) {
      const current = moment().format("YYYY-MM-DD");
      setNonDisabledDay(current);
      const url = new URL(window.location);
      url.searchParams.delete("time");
      url.searchParams.delete("date");
      window.history.replaceState({}, "", url);
    } else {
      seCurrenttStep(3);
    }
    seCurrenttStep(step);
  };

  const handleOnServiceSelect = async (item) => {
    if (currentStep === 1) {
      handleOnSearch("");
      setSearchText("");
    }
    setItemBeingSelected(item);
    const deps = Utilities.getServiceDependencies(originalServices, item);
    console.log(deps);
    setItemBeingSelectedDependencies(deps);

    if (deps && currentStep === 1) {
      if (deps.length > 0) {
        if (!Utilities.isServiceSelected(item, selectedServices)) {
          setIsMultiSelectConfirmationVisible(true);
        } else {
          addOrEditSelectedServices([
            {
              id_service: item.id_service,
              name: item.name,
              idStaffItem: item.idStaffItem ? item.idStaffItem : "",
              selectionMode: Utilities.MANUAL,
              sortOrder: selectedServices.length + 1,
            },
          ]);
        }
      } else {
        addOrEditSelectedServices([
          {
            id_service: item.id_service,
            name: item.name,
            idStaffItem: item.idStaffItem ? item.idStaffItem : "",
            selectionMode: Utilities.MANUAL,
            sortOrder: selectedServices.length + 1,
          },
        ]);
      }
    } else {
      addOrEditSelectedServices([
        {
          id_service: item.id_service,
          name: item.name,
          idStaffItem: item.idStaffItem ? item.idStaffItem : "",
          selectionMode: Utilities.MANUAL,
          sortOrder: selectedServices.length + 1,
        },
      ]);
    }
  };

  const handleOnServiceDeSelect = (item) => {
    if (currentStep === 1) {
      handleOnSearch("");
      setSearchText("");
    }
    const servicesToFilter =
      currentStep === 1 ? selectedServices : selectedServicesForNextStep;
    servicesToFilter.forEach((element) => {
      if (element.id_service === item.id_service) {
        if (element.selectionMode === Utilities.MANUAL) {
          removeSelectedService(item);
        }
      }
    });
  };

  const removeSelectedService = (item) => {
    const servicesToFilter =
      currentStep === 1 ? selectedServices : selectedServicesForNextStep;
    const not2Delete = servicesToFilter.filter((enumItem) => {
      let mustKeep = true;

      //rimuovo l'elemento
      if (item.id_service === enumItem.id_service) {
        mustKeep = false;
      }

      //rimuovo gli elementi inclusi automaticamente
      if (
        enumItem.parentItemId === item.id_service &&
        enumItem.selectionMode === Utilities.INCLUDED
      ) {
        mustKeep = false;
      }
      return mustKeep;
    });
    if (currentStep === 1) {
      setSelectedServices(not2Delete);
    } else {
      setSelectedServicesForNextStep(not2Delete);
    }
  };

  const handleOnSearch = (searchText) => {
    let filteredServices;
    if (searchText !== "") {
      filteredServices = originalServices.filter((item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      filteredServices = originalServices;
    }
    const array = removeDuplicates(filteredServices, "id_service");
    setServices(array);
  };

  const handleConfirmationMultiSelectButtonClick = () => {
    const services2Add = [];
    //Utilities.removeSelectedService(itemBeingSelected, selectedServices);
    services2Add.push({
      ...{
        id_service: itemBeingSelected.id_service,
        name: itemBeingSelected.name,
        idStaffItem: itemBeingSelected.idStaffItem,
        selectionMode: Utilities.MANUAL,
        sortOrder: selectedServices.length + 1,
      },
      selectionMode: Utilities.MANUAL,
    });
    let order = selectedServices.length + 1;
    itemBeingSelectedDependencies.forEach((element) => {
      order++;
      //const item = Utilities.getItemFromSelectedServices(element, selectedServices);
      services2Add.push({
        id_service: element.id_service,
        name: element.name,
        idStaffItem: element.idStaffItem,
        selectionMode: Utilities.INCLUDED,
        parentItemId: itemBeingSelected.id_service,
        sortOrder: order,
      });
    });

    addOrEditSelectedServices(services2Add);
    setIsMultiSelectConfirmationVisible(false);
  };

  const addOrEditSelectedServices = (services2Add) => {
    const servicesToFilter =
      currentStep === 1 ? selectedServices : selectedServicesForNextStep;
    const services2Keep = servicesToFilter.filter((item) => {
      const found = services2Add.find((selectedService) => {
        if (selectedService.id_service === item.id_service) {
          selectedService.sortOrder = item.sortOrder;
        }
        return selectedService.id_service === item.id_service;
      });
      if (found) {
        return false;
      } else {
        return true;
      }
    });
    if (currentStep === 1) {
      setSelectedServices([...services2Keep, ...services2Add]);
    } else {
      setSelectedServicesForNextStep([...services2Keep, ...services2Add]);
    }
  };

  // we don't want to select from holidays/disable days.
  const setNonDisabledDay = (current) => {
    if (preferences.disabledDays.includes(current)) {
      const formattedDate = moment(current);
      const nextDay = formattedDate.add(1, "day");
      const next = nextDay.format("YYYY-MM-DD");
      setNonDisabledDay(next);
    } else {
      const value = moment(current);
      setSelectedDay(value._d);
    }
  };

  useEffect(() => {
    if (currentStep === 2) {
      const currentUrl = new URL(window.location.href);
      const queryParams = new URLSearchParams(currentUrl.search);
      if (queryParams.get("time")) {
        const timestampInSeconds = queryParams.get("time");
        const timestampInMilliseconds = timestampInSeconds * 1000;

        const specificMoment = moment(timestampInMilliseconds);
        const time = specificMoment.format("HH:mm");

        handleTimeSelected({
          time: time,
          slotts: +queryParams.get("time"),
        });
        gotoNext();
      }
    }
  }, [currentStep]);

  const gotoNext = (event, preloadedDate) => {
    const currentUrl = new URL(window.location.href);
    const queryParams = new URLSearchParams(currentUrl.search);
    const stepParam = queryParams.get("step");
    const servicesParam = queryParams.get("services");

    let servicesArray = [];
    if (stepParam && servicesParam) {
      servicesArray = servicesParam
        .replace(/\s/g, "")
        .slice(1, -1)
        .split(",")
        .map(Number);
    }

    if (currentStep === 1 || currentStep === 1.2) {
      console.log("selected services", selectedServices);

      let allSelectedServices = selectedServices;
      if (servicesArray.length > 0) {
        allSelectedServices = [
          ...convertServiceIdsToSelectedServices(
            servicesArray,
            originalServices
          ),
          ...selectedServices,
        ];
      }

      getFreeSlots(
        moment()._d,
        servicesArray,
        allSelectedServices,
        preferences
      ).then((data) => {
        const noAvailableSlot = [];
        for (let i = 0; i < data.length; i++) {
          if (
            data[i].slots[0].times.length === 0 &&
            data[i].slots[1].times.length === 0
          ) {
            noAvailableSlot.push(data[i].date);
          }
        }
        setNoAvailableSlots(noAvailableSlot);
        setPreferences(preferences);
        if (data[0]?.times?.length === 0 && data[1]?.times?.length === 0) {
          const formattedDate = moment(selectedDay).format("YYYY-MM-DD");
          const nextDay = moment(formattedDate).add(1, "day");
          const next = nextDay.format("YYYY-MM-DD");
          setNonDisabledDay(next);
        } else {
          setFreeSlots(data);
        }
      });
    }

    if (currentStep === 1) {
      setNoAvailableSlots(undefined);
      setSelectedTime(undefined);
      setStepBetween1and2Loading(true);
      const date = queryParams.get("date");
      const current =
        date !== null
          ? moment(date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
      setNonDisabledDay(current);

      mutate();
    } else if (currentStep === 1.2) {
      setNoAvailableSlots(undefined);
      setSelectedTime(undefined);
      const date = queryParams.get("date");

      const current =
        date !== null
          ? moment(date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
      setNonDisabledDay(current);
      seCurrenttStep(2);
      setSelectedServices([
        ...selectedServices,
        ...selectedServicesForNextStep,
      ]);
      setSelectedServicesForNextStep([]);
    } else if (currentStep === 2) {
      if (Object.keys(cookieData).length > 0) {
        const parsedData = JSON.parse(cookieData);

        doBooking(services, selectedServices, selectedTime.slotts, {
          nameFirst: parsedData.fName,
          nameLast: parsedData.lName,
          phone: parsedData.mobile,
          email: parsedData.email,
          other: "",
        }).then((value) => {
          window.flutter_inappwebview?.callHandler("myHandlerName", value);
          seCurrenttStep(3);
          setFinished(true);
        });
      } else {
        seCurrenttStep(3);
      }
    }
  };

  const handleDaySelected = (day) => {
    if (day) {
      console.log(day);
      setSelectedDay(day);
    }
  };

  const handleTimeSelected = (time) => {
    console.log(time);
    const _selectedTime = time;
    setSelectedTime(_selectedTime);
  };

  const handleOnBookStep3 = () => {
    if (mobile === "") {
      setErrorMobile(true);
    } else {
      setErrorMobile(false);
      if (isConfirmButtonEnabled) {
        if (!isPhoneVerified) {
          setIsInFlight(true);
          confirmNumber({ phone })
            .then(() => {
              setShowMobileVerificationModal(true);
              setIsInFlight(false);
            })
            .catch((error) => {
              setIsInFlight(false);
              setFinishedWithError(true);
              setFinished(false);
              seCurrenttStep(2);
            });
        } else {
          if (payOnline) {
            setShowStripeModal(true);
          } else {
            setFinishedWithError(false);
            setFinished(true);
            seCurrenttStep(3);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (bookingData && bookingData.preferences) {
      setupPreferences(bookingData.preferences);
    }
  }, [bookingData]);

  // Add new useLayoutEffect to handle direct service-employee selection
  useLayoutEffect(() => {
    if (
      bookingData?.preferences.predefined.id_service &&
      bookingData?.preferences.predefined.id_employee
    ) {
      const serviceId = bookingData?.preferences.predefined.id_service;
      const employeeId = bookingData?.preferences.predefined.id_employee;
      console.log("serviceId", serviceId);
      console.log("employeeId", employeeId);
      if (serviceId && employeeId && bookingData?.services) {
        // Mostra subito il loader
        setIsLoading(true);

        const service = originalServices.find(
          (s) => s.id_service === serviceId.toString()
        );

        if (service) {
          const serviceSelection = {
            id_service: service.id_service,
            name: service.name,
            idStaffItem: employeeId.toString(),
            selectionMode: Utilities.MANUAL,
            sortOrder: 1,
          };

          // Seleziona il servizio e passa direttamente allo step 2
          setSelectedServices([serviceSelection]);
          addOrEditSelectedServices([serviceSelection]);

          // Ottieni gli slot liberi e passa allo step 2
          getFreeSlots(moment()._d, [], [serviceSelection], preferences)
            .then((data) => {
              const noAvailableSlot = [];
              for (let i = 0; i < data.length; i++) {
                if (
                  data[i].slots[0].times.length === 0 &&
                  data[i].slots[1].times.length === 0
                ) {
                  noAvailableSlot.push(data[i].date);
                }
              }
              setNoAvailableSlots(noAvailableSlot);
              setPreferences(preferences);
              setFreeSlots(data);

              // Imposta la data corrente
              const current = moment().format("YYYY-MM-DD");
              setNonDisabledDay(current);

              // Passa allo step 2
              seCurrenttStep(2);
              setIsLoading(false);
            })
            .catch((error) => {
              console.error("Error loading slots:", error);
              setIsLoading(false);
            });

          setHasProcessedServices(true);
        } else {
          setIsLoading(false);
        }
      }
    }
  }, [bookingData, originalServices]);

  if (bookingData === undefined) return <div></div>;

  if (bookingData !== undefined)
    return (
      <ThemeProvider theme={theme}>
        <>
          {isLoading && (
            <div className={classes["loading-overlay"]}>
              <div className={classes.spinner}></div>
            </div>
          )}
          <div
            className={classes["widget-container"]}
            style={
              isMultiSelectConfirmationVisible ||
              showMobileVerificationModal ||
              showStripeModal
                ? {
                    overflowY: "hidden",
                    overflowX: "hidden",
                  }
                : {}
            }
          >
            <div>{/*JSON.stringify(selectedServices)*/}</div>
            {/* Need to show steps if not finished yet. */}
            {!finished && (
              <div className={classes["header"]}>
                <Stepper
                  onStepChange={onStepChange}
                  currentStep={currentStep}
                />
                {/* <div className={classes["log-in"]} onClick={() => navigate('/login')}>
            {!isMobile && <RiLoginBoxLine className={classes["icon"]} size={24}/>}
            <p className={classes["heading"]}>accedi</p>
          </div> */}
              </div>
            )}
            <Search
              currentStep={currentStep}
              finished={finished}
              handleOnSearch={handleOnSearch}
              setSearchText={setSearchText}
              searchText={searchText}
            />

            {!finished && currentStep === 1 && (
              <Step1
                data={getStructuredServices(services, employees, "")}
                selectedServices={selectedServices}
                onServiceSelect={handleOnServiceSelect}
                onServiceDeSelect={handleOnServiceDeSelect}
                onSearch={handleOnSearch}
                onBook={gotoNext}
                isMobile={isMobile}
                stepBetween1and2Loading={stepBetween1and2Loading}
                currentStep={currentStep}
              />
            )}

            {!finished &&
              currentStep === 2 &&
              freeSlots &&
              noAvailableSlots !== undefined && (
                <Step2
                  services={originalServices}
                  employees={employees}
                  selectedServices={selectedServices}
                  onBack={() => onStepChange(currentStep - 1)}
                  onDaySelected={handleDaySelected}
                  freeSlots={freeSlots}
                  onTimeSelected={handleTimeSelected}
                  selectedTime={selectedTime}
                  onBookStep2={gotoNext}
                  width={1000}
                  preferences={preferences}
                  finishedWithError={finishedWithError}
                  selectedDay={selectedDay}
                  setSelectedDay={setSelectedDay}
                  noAvailableSlots={noAvailableSlots}
                />
              )}

            {!finished && currentStep === 3 && (
              <Step3
                services={originalServices}
                employees={employees}
                selectedServices={selectedServices}
                onBack={() => seCurrenttStep(currentStep - 1)}
                selectedDay={selectedDay}
                selectedTime={selectedTime}
                setFinishedWithError={setFinishedWithError}
                setFinished={setFinished}
                seCurrenttStep={seCurrenttStep}
                stripe_key={preferences.st_k}
                stripe_secret={preferences.st_s}
                setIsConfirmButtonEnabled={setIsConfirmButtonEnabled}
                isConfirmButtonEnabled={isConfirmButtonEnabled}
                handleOnBookStep3={handleOnBookStep3}
                setIsPhoneVerified={setIsPhoneVerified}
                isPhoneVerified={isPhoneVerified}
                setShowMobileVerificationModal={setShowMobileVerificationModal}
                showMobileVerificationModal={showMobileVerificationModal}
                setShowStripeModal={setShowStripeModal}
                showStripeModal={showStripeModal}
                setPayOnline={setPayOnline}
                payOnline={payOnline}
                phone={phone}
                setPhone={setPhone}
                setIsInFlight={setIsInFlight}
                isInFlight={isInFlight}
                control={control}
                watch={watch}
                isValid={isValid}
                trigger={trigger}
                confirmButtonClicked={confirmButtonClicked}
                setConfirmButtonClicked={setConfirmButtonClicked}
                errorMobile={errorMobile}
                setErrorMobile={setErrorMobile}
                setMobile={setMobile}
                mobile={mobile}
                setPrivacy={setPrivacy}
                privacy={privacy}
                setErrorInStripe={setErrorInStripe}
                isOnlinePaymentEnabled={
                  bookingData.preferences.online_payment_enabled ?? true
                }
                tos={bookingData.preferences.terms_conditions_link}
                privacyPolicy={bookingData.preferences.privacy_policy_link}
              />
            )}

            {finished && (
              <Finish
                selectedTime={selectedTime}
                selectedDay={selectedDay}
                onAddToCalendar={() => {}}
                setFinished={setFinished}
                seCurrenttStep={seCurrenttStep}
                setPrivacy={setPrivacy}
                privacy={privacy}
                payOnline={payOnline}
                error={errorInStripe}
                setFinishedWithError={setFinishedWithError}
                setErrorInStripe={setErrorInStripe}
              />
            )}

            {!finished && currentStep === 1.2 && (
              <Stepbetween1and2
                data={getStructuredServices(services, employees, "")}
                selectedServices={selectedServicesForNextStep}
                onServiceSelect={handleOnServiceSelect}
                onServiceDeSelect={handleOnServiceDeSelect}
                onSearch={handleOnSearch}
                onBook={gotoNext}
                isMobile={isMobile}
                currentStep={currentStep}
              />
            )}

            <CustomModal
              isMultiSelectConfirmationVisible={
                isMultiSelectConfirmationVisible
              }
              setIsMultiSelectConfirmationVisible={
                setIsMultiSelectConfirmationVisible
              }
              itemBeingSelected={itemBeingSelected}
              itemBeingSelectedDependencies={itemBeingSelectedDependencies}
              handleConfirmationMultiSelectButtonClick={
                handleConfirmationMultiSelectButtonClick
              }
            />
            {!finished && currentStep !== 1.2 && (
              <div style={{}} className={classes["footer"]}>
                {isPending && (
                  <div className={classes["booking-data-loading"]}>
                    Loading...
                  </div>
                )}
                {errorBookingData && (
                  <div className={classes["booking-data-error"]}>
                    An error has occurred. Please try again
                  </div>
                )}
                <div>
                  <div className={classes["exagon-logo-text"]}>Powered by</div>

                  <img
                    className={classes["exagon-logo"]}
                    src={bookingData.preferences.logo_colorami}
                    alt=""
                  />
                </div>
              </div>
            )}
          </div>
          {isMobile && selectedServices.length > 0 && (
            <Cart
              selectedServices={
                currentStep === 1.2
                  ? selectedServicesForNextStep
                  : selectedServices
              }
              onServiceDeSelect={handleOnServiceDeSelect}
              onBook={gotoNext}
              stepBetween1and2Loading={stepBetween1and2Loading}
              selectedTime={selectedTime}
              currentStep={currentStep}
              isConfirmButtonEnabled={isConfirmButtonEnabled}
              handleOnBookStep3={handleOnBookStep3}
              finished={finished}
              isInFlight={isInFlight}
              setConfirmButtonClicked={setConfirmButtonClicked}
              trigger={trigger}
              payOnline={payOnline}
            />
          )}
        </>
      </ThemeProvider>
    );
};

export default Widget;
